export default __webpack_public_path__ + "static/media/drive.550a2ecc.png";